'use client';

import { useState, useEffect } from 'react';
import { usePathname } from 'next/navigation';
import programAudience from '@/data/programAudience';

export default function ProgramAudienceSection() {
  const [audienceData, setAudienceData] = useState(null);
  const pathname = usePathname();

  useEffect(() => {
    // Extract the slug based on the path pattern
    let slug;
    const pathParts = pathname.split('/').filter(part => part);
    
    // Check if it's a workshop path
    if (pathParts[0] === 'workshops') {
      // For workshop paths, use format "workshops/[slug]"
      slug = `workshops/${pathParts[1]}`;
    } else {
      // For regular paths, just use the last part as the slug
      slug = pathParts[pathParts.length - 1];
    }
    
    const matchingAudience = programAudience.find(program => program.slug === slug);
    
    if (matchingAudience) {
      setAudienceData(matchingAudience);
    } else {
      // Fallback to first program or null if array is empty
      setAudienceData(programAudience.length > 0 ? programAudience[0] : null);
    }
  }, [pathname]);

  if (!audienceData) {
    return null;
  }

  return (
    <div className="w-full mt-16">
      <h2 className="text-[#002726] text-2xl md:text-[32px]  font-medium mb-6">
        {audienceData.heading}
      </h2>
      
      <p className="text-[#002726] text-sm md:text-base mb-8">
        {audienceData.description}
      </p>
      
      <div className="md:bg-[#fffaf1] md:p-8 rounded-2xl">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {audienceData.suitableFor.map((audience, index) => (
            <div key={index} className="flex items-start">
              <div className="mt-1 mr-3 text-[#4CAF50]">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7 13L10 16L17 9" stroke="#4CAF50" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <circle cx="12" cy="12" r="10" stroke="#4CAF50" strokeWidth="2"/>
                </svg>
              </div>
              <span className="text-[#002726] md:font-medium font-normal text-sm md:text-xl">{audience}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}